var r=r=>Array.isArray(r);export{r as isStringArray};
//# sourceMappingURL=isStringArray.js.map